import { useContext } from 'react'

import { WDBOpsContext } from '../contexts/wdbOps'

export const useWDBOps = () => {
    const context = useContext(WDBOpsContext)
    return context
}
